import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const AlertNotices = ({ onlyIcon = false }) => (
  <div className="flex">
    <ExclamationTriangleIcon className="h-6 w-6" />
    {!onlyIcon && <p className="ml-2 text-[15px]">Avisos</p>}
  </div>
)

export default AlertNotices
